
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import t from "@common/src/i18n/t";
const warehouse = namespace("warehouse");
@Component({})
export default class Warehouse extends Vue {
  @warehouse.Action createWarehouse;
  @warehouse.Action getWarehouseList;
  @warehouse.Action updateWarehouse;
  warehouseFormRules: any = {
    warehouseName: [{ required: true, message: t("v213.please-enter-the-warehouse-name"), trigger: "blur" }],
    defaultWarehouse: [{ required: true, message: t("setting.choose-whether-default"), trigger: "blur" }],
    status: [
      {
        required: true,
        message: t("setting.select-whether-enable"),
        trigger: "blur"
      }
    ]
  };
  addEmptyData: any = {
    warehouseName: "",
    address: "",
    defaultWarehouse: 0,
    status: 1,
    disabled: false,
    manual: true
  };
  warehouseList: any[] = [];
  created() {
    this.init();
  }
  init() {
    this.getWarehouseList({
      pageNum: 1,
      pageSize: 100
    }).then(data => {
      this.warehouseList = data.data.list.map(item => {
        item.disabled = true;
        return item;
      });
    });
  }
  handleValueChange(i) {
    this.warehouseList[i].disabled = false;
  }
  submitForm(formName, i) {
    (this.$refs[formName][i] as any).validate(valid => {
      if (valid) {
        console.log("success");
        if (this.warehouseList[i].manual) {
          this.addWarehouse(i);
        } else {
          this.editWarehouse(i);
        }
      } else {
        console.log("error submit!!");
        return false;
      }
    });
  }
  addWarehouseItem() {
    this.warehouseList.push(Object.assign({}, this.addEmptyData));
  }
  async addWarehouse(i) {
    await this.createWarehouse(this.warehouseList[i]);
    this.$message.success(t("finance.new-success"));
    this.init();
  }
  async editWarehouse(i) {
    await this.updateWarehouse(this.warehouseList[i]);
    this.$message.success(t("base.save-success"));
    this.init();
  }
}
